"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePicker = exports.isFileDescriptor = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var isFileDescriptor = function (toBeDetermined) {
    return ((toBeDetermined === null || toBeDetermined === void 0 ? void 0 : toBeDetermined.file) &&
        (typeof toBeDetermined.file === 'string' ||
            toBeDetermined.file instanceof File));
};
exports.isFileDescriptor = isFileDescriptor;
var FilePicker = function (_a) {
    var accept = _a.accept, _b = _a.align, align = _b === void 0 ? 'left' : _b, className = _a.className, disabled = _a.disabled, _c = _a.layout, layout = _c === void 0 ? 'list' : _c, limitReached = _a.limitReached, multiple = _a.multiple, onDelete = _a.onDelete, onDownload = _a.onDownload, onReplace = _a.onReplace, onSelected = _a.onSelected, value = _a.value, rest = __rest(_a, ["accept", "align", "className", "disabled", "layout", "limitReached", "multiple", "onDelete", "onDownload", "onReplace", "onSelected", "value"]);
    var inputRef = react_1.default.useRef();
    var handleButtonClick = function () { return inputRef.current.click(); };
    var handleFileReplace = function (file) { return function (e) {
        return onReplace ? onReplace({ file: file, newFile: e.target.files[0] }) : undefined;
    }; };
    var handleFileDelete = function (file) { return function () {
        return onDelete ? onDelete(file) : undefined;
    }; };
    var handleFileDownload = function (file) { return function () {
        return onDownload ? onDownload(file) : undefined;
    }; };
    var handleFileChange = function (e) {
        return onSelected(e.target.files);
    };
    var valueArr = exports.isFileDescriptor(value) ? [value] : value;
    var inProgress = function (file) {
        return !(file.uploadProgress === undefined || file.uploadProgress === 100);
    };
    var typesNote = rest.typesNote;
    if (accept && typesNote === undefined) {
        typesNote = "Allowed file types: " + accept;
    }
    var classes = classnames_1.default('FilePicker', className, {
        'FilePicker--disabled': disabled,
        'FilePicker--grid': layout === 'grid',
        'FilePicker--list': layout === 'list',
        'FilePicker--align-center': align === 'center',
    });
    return (react_1.default.createElement("div", { className: classes }, valueArr === null || valueArr === void 0 ? void 0 :
        valueArr.map(function (file, index) { return (react_1.default.createElement("div", { key: index, className: classnames_1.default('FilePicker__File') },
            react_1.default.createElement(__1.Icon, { name: "description", size: 24, className: "FilePicker__File__Icon" }),
            react_1.default.createElement(__1.BodyText, { className: "FilePicker__File__Name" }, file.displayName ||
                (typeof file.file === 'string'
                    ? file.file
                    : file.file.name)),
            inProgress(file) ? (react_1.default.createElement("div", null, "Loading...")) : (react_1.default.createElement(react_1.default.Fragment, null,
                onReplace && (react_1.default.createElement("label", { className: "FilePicker__File__ActionIcon" },
                    react_1.default.createElement(__1.Tooltip, { text: "Replace file" },
                        react_1.default.createElement(__1.Icon, { name: "cached", size: 24 })),
                    react_1.default.createElement("input", { type: "file", className: "FilePicker__Input", onChange: handleFileReplace(file), accept: accept, disabled: disabled }))),
                (onDownload || file.downloadLink) && (react_1.default.createElement(__1.Tooltip, { text: "Download file", className: "FilePicker__File__ActionIcon" }, file.downloadLink ? (react_1.default.createElement(__1.Icon, { name: "get_app", size: 24, onClick: handleFileDownload(file), href: file.downloadLink })) : (react_1.default.createElement(__1.Icon, { name: "get_app", size: 24, onClick: handleFileDownload(file) })))),
                onDelete && (react_1.default.createElement(__1.Tooltip, { text: "Remove file", className: "FilePicker__File__ActionIcon" },
                    react_1.default.createElement(__1.Icon, { name: "delete", size: 24, onClick: handleFileDelete(file) }))))))); }),
        (!valueArr || (multiple && !limitReached)) && (react_1.default.createElement("span", { className: "FilePicker__File__ActionContainer" },
            react_1.default.createElement("label", null,
                react_1.default.createElement(__1.Button, { default: true, disabled: disabled, iconName: "attach_file", onClick: handleButtonClick },
                    "Choose File",
                    multiple && 's'),
                react_1.default.createElement("input", { type: "file", className: "FilePicker__Input", onChange: handleFileChange, multiple: multiple, accept: accept, disabled: disabled, value: "", ref: inputRef })),
            typesNote && (react_1.default.createElement(__1.BodyText, { size: "xsmall", subdued: true, className: "m-t-1 FilePicker__Note" }, typesNote))))));
};
exports.FilePicker = FilePicker;
//# sourceMappingURL=FilePicker.js.map